const getEnvironmentConfig = () => {
  switch (process.env.REACT_APP_ENV) {
    case 'staging':
      return {
        baseUrl: 'https://api.xarothi.in/',
      };
    case 'prod':
      return {
        baseUrl: 'https://api.xarothi.in/',
      };
    default:
      return {
        baseUrl: '/',
      };
  }
};

export const BASE_URL = getEnvironmentConfig().baseUrl;
export const API_REQUEST_TIMEOUT = 30000;

// Sent on every request via `x-client-name` so the backend knows exactly which
// frontend a call came from. Platform is fixed for a web build (matches the
// backend Platform enum). Pair: x-client-platform.
export const CLIENT_NAME = 'xarothi-admin-webapp';
export const CLIENT_PLATFORM = 'WEB';
